import axiosInstance from "../../utils/axiosInstance";
import {
  setCategoryProducts,
  setErrorLoadingCategoryProducts,
  setErrorLoadingProduct,
  setErrorLoadingProducts,
  setLoadingCategoryProducts,
  setLoadingProduct,
  setLoadingProducts,
  setProduct,
  setProducts,
} from "../slices/product";

import { toast } from "react-toastify";

export const getProducts = () => async (dispatch) => {
  dispatch(setLoadingProducts());
  try {
    const { data } = await axiosInstance.get(`/products`);
    if (data.status === "SUCCESS") {
      dispatch(setProducts(data.data));
    }
  } catch (error) {
    dispatch(
      setErrorLoadingProducts(
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message
          ? error.message
          : "An expected error has occured. Please try again later."
      )
    );
  }
};

export const getCategoryProducts = (productCategory) => async (dispatch) => {
  dispatch(setLoadingCategoryProducts());
  try {
    const { data } = await axiosInstance.get(
      `/products/category/${productCategory}`
    );
    if (data.status === "SUCCESS") {
      dispatch(setCategoryProducts(data.data));
    }
  } catch (error) {
    dispatch(
      setErrorLoadingCategoryProducts(
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message
          ? error.message
          : "An expected error has occured. Please try again later."
      )
    );
  }
};

export const getProductById = (id) => async (dispatch) => {
  dispatch(setLoadingProduct());
  try {
    const { data } = await axiosInstance.get(`/products/${id}`);
    if (data.status === "SUCCESS") {
      dispatch(setProduct(data.data));
    }
  } catch (error) {
    dispatch(
      setErrorLoadingProduct(
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message
          ? error.message
          : "An expected error has occured. Please try again later."
      )
    );
  }
};
